/**
 * Open a URL outside the app shell.
 *
 * - Web: standard `window.open` in a new tab (unchanged behavior).
 * - Native (Capacitor): uses @capacitor/browser to open the system browser
 *   (Chrome Custom Tabs / SFSafariViewController) so signup / forgot-password
 *   flows happen on lanerunner.com and never inside the native WebView.
 *
 * The `@capacitor/browser` import is dynamic and gated behind
 * `isNativePlatform()`, so Vite tree-shakes it out of the web bundle.
 */
import { isNativePlatform } from "@/lib/platform";

export async function openExternal(url: string): Promise<void> {
  if (isNativePlatform()) {
    try {
      const { Browser } = await import("@capacitor/browser");
      await Browser.open({ url });
      return;
    } catch (err) {
      console.error("[openExternal] Capacitor Browser failed, falling back", err);
    }
  }
  if (typeof window !== "undefined") {
    window.open(url, "_blank", "noopener,noreferrer");
  }
}
